import {
  apiRequest,
  masterWorkUnit,
  masterEmployeeStatus,
  presensiexport,
  presensiketidakhadiranexport,
  masterEmployeeCategories,
  getEarlyWarningAbsen,
  getEmployeeListWarning,
  exportWarningList,
} from "../../../../../services/adapters/kepegawaian/presensiService";

class IndexRepository {
  fetchWorkUnit = async (query) => {
    return await apiRequest(
      "get",
      masterWorkUnit,
      {
        params: query,
      },
      true
    );
  };
  fetchEmployeeStatus = async (query) => {
    return await apiRequest(
      "get",
      masterEmployeeStatus,
      {
        params: query,
      },
      true
    );
  };

  fetchPresensiExport = async (query) => {
    return await apiRequest(
      "get",
      presensiexport,
      {
        params: query,
      },
      true
    );
  };

  fetchPresensiKetidakhadiranExport = async (query) => {
    return await apiRequest(
      "get",
      presensiketidakhadiranexport,
      {
        params: query,
      },
      true
    );
  };

  fetchEmployeeCategories = async (query) => {
    return await apiRequest(
      "get",
      masterEmployeeCategories,
      {
        params: query,
      },
      true
    );
  };

  fetchWarningAbsen = async (query) => {
    return await apiRequest(
      "get",
      getEarlyWarningAbsen,
      {
        params: query,
      },
      true
    );
  };

  fetchEmployeeListWarning = async (query) => {
    return await apiRequest(
      "get",
      getEmployeeListWarning,
      {
        params: query,
      },
      true
    );
  };

  fetchexportWarningList = async (query) => {
    return await apiRequest(
      "get",
      exportWarningList,
      {
        params: query,
      },
      true
    );
  };
}

export default IndexRepository;
